// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
    margin-right: 5px;
}

select {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 2px;
    outline: none;
    /* appearance: none; */
    /* background: white url('data:image/svg+xml,<svg xmlns="http://w...content-available-to-author-only...3.org/2000/svg" viewBox="0 0 24 24" fill="%23333333"><path d="M7 10l5 5 5-5z"/></svg>') no-repeat right 10px center; */
    background-size: 16px 16px;
}

select:focus {
    border-color: #1E1F23;
    box-shadow: 0 0 5px #1E1F23;
}

.nav-link.active {
    background-color: #1E1F23!important;
}

.nav-link {
    color: #1E1F23;
}

.nav-link:hover {
    color: #757886!important;
}

.nav-tabs .nav-link.active {
    color: #f9f9f9;
}

/* CSV Upload Widget Styles */
.csv-upload-widget {
    padding: 20px;
    border: 2px dashed #ccc;
    border-radius: 8px;
    background-color: #f9f9f9;
    text-align: center;
    margin: 10px 0;
}

.upload-section {
    margin-bottom: 15px;
}

.file-input-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
}

.upload-status {
    margin-top: 10px;
    padding: 8px;
    background-color: #e3f2fd;
    border-radius: 4px;
    color: #1E1F23;
}

.upload-result {
    margin-top: 10px;
    padding: 8px;
    border-radius: 4px;
}

.upload-result.success {
    background-color: #e8f5e8;
    color: #2e7d32;
    border: 1px solid #4caf50;
}

.upload-result.error {
    background-color: #ffebee;
    color: #c62828;
    border: 1px solid #f44336;
}

.output-path {
    margin-top: 8px;
    padding: 6px;
    background-color: #f0f8ff;
    border-radius: 4px;
    font-size: 12px;
}

.output-path code {
    background-color: #e8e8e8;
    padding: 2px 4px;
    border-radius: 3px;
    font-family: 'Courier New', monospace;
    color: #333;
}

.file-info-section {
    margin-top: 15px;
    padding: 15px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    text-align: left;
}

.file-info-header {
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
    font-size: 14px;
}

.file-info-details {
    font-size: 13px;
    line-height: 1.4;
}

.file-info-details div {
    margin-bottom: 5px;
}

.file-info-details strong {
    color: #555;
    min-width: 100px;
    display: inline-block;
}

.upload-actions {
    margin-top: 15px;
}

.csv-upload-widget .btn {
    font-size: 14px;
    padding: 8px 16px;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.csv-upload-widget .btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.csv-upload-widget .btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* The Vega output's canvas as a block, not inline. An inline canvas sits on a
   text baseline and leaves a descender gap under it, so a container-sized chart
   came out 4 px taller than its mount and the mount scrolled both ways (#496). */
.curio-vega-mount > canvas {
    display: block;
    margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/editing/NodeEditor.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,6NAA6N;IAC7N,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;iFAEiF;AACjF;IACI,cAAc;IACd,cAAc;AAClB","sourcesContent":["label {\n    margin-right: 5px;\n}\n\nselect {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 2px;\n    outline: none;\n    /* appearance: none; */\n    /* background: white url('data:image/svg+xml,<svg xmlns=\"http://w...content-available-to-author-only...3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"%23333333\"><path d=\"M7 10l5 5 5-5z\"/></svg>') no-repeat right 10px center; */\n    background-size: 16px 16px;\n}\n\nselect:focus {\n    border-color: #1E1F23;\n    box-shadow: 0 0 5px #1E1F23;\n}\n\n.nav-link.active {\n    background-color: #1E1F23!important;\n}\n\n.nav-link {\n    color: #1E1F23;\n}\n\n.nav-link:hover {\n    color: #757886!important;\n}\n\n.nav-tabs .nav-link.active {\n    color: #f9f9f9;\n}\n\n/* CSV Upload Widget Styles */\n.csv-upload-widget {\n    padding: 20px;\n    border: 2px dashed #ccc;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n    text-align: center;\n    margin: 10px 0;\n}\n\n.upload-section {\n    margin-bottom: 15px;\n}\n\n.file-input-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 15px;\n}\n\n.upload-status {\n    margin-top: 10px;\n    padding: 8px;\n    background-color: #e3f2fd;\n    border-radius: 4px;\n    color: #1E1F23;\n}\n\n.upload-result {\n    margin-top: 10px;\n    padding: 8px;\n    border-radius: 4px;\n}\n\n.upload-result.success {\n    background-color: #e8f5e8;\n    color: #2e7d32;\n    border: 1px solid #4caf50;\n}\n\n.upload-result.error {\n    background-color: #ffebee;\n    color: #c62828;\n    border: 1px solid #f44336;\n}\n\n.output-path {\n    margin-top: 8px;\n    padding: 6px;\n    background-color: #f0f8ff;\n    border-radius: 4px;\n    font-size: 12px;\n}\n\n.output-path code {\n    background-color: #e8e8e8;\n    padding: 2px 4px;\n    border-radius: 3px;\n    font-family: 'Courier New', monospace;\n    color: #333;\n}\n\n.file-info-section {\n    margin-top: 15px;\n    padding: 15px;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    text-align: left;\n}\n\n.file-info-header {\n    font-weight: bold;\n    margin-bottom: 10px;\n    color: #333;\n    font-size: 14px;\n}\n\n.file-info-details {\n    font-size: 13px;\n    line-height: 1.4;\n}\n\n.file-info-details div {\n    margin-bottom: 5px;\n}\n\n.file-info-details strong {\n    color: #555;\n    min-width: 100px;\n    display: inline-block;\n}\n\n.upload-actions {\n    margin-top: 15px;\n}\n\n.csv-upload-widget .btn {\n    font-size: 14px;\n    padding: 8px 16px;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n}\n\n.csv-upload-widget .btn:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.csv-upload-widget .btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* The Vega output's canvas as a block, not inline. An inline canvas sits on a\n   text baseline and leaves a descender gap under it, so a container-sized chart\n   came out 4 px taller than its mount and the mount scrolled both ways (#496). */\n.curio-vega-mount > canvas {\n    display: block;\n    margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
